import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  loadCompanyRequests as loadCompanyRequestsAction,
  rejectCompanyRequest as rejectCompanyRequestAction,
  setRejectCompanyRequestModalVisibility as setRejectCompanyRequestModalVisibilityAction,
  setRejectedSuccessModalVisibility as setRejectedSuccessModalVisibilityAction,
} from '../../slices/company_request_slice'
import { loadCompanies as loadCompaniesAction } from '../../slices/company_slice'
import CompanyFormModal from '../modals/CompanyFormModal'
import ConfirmRejectCompanyContent from './ConfirmRejectCompanyContent'
import SuccessModalContent from './SuccessModalContent'

export function RejectCompany() {
  const { currentRequest, rejectCompanyRequestModalVisibility, rejectedSuccessModalVisibility } = useSelector(
    (state) => state.companyRequest
  )
  const dispatch = useDispatch()

  const company = useMemo(() => {
    if (!currentRequest) return

    return currentRequest.company_alias.company
  }, [currentRequest])

  const onClickBack = () => {
    dispatch(setRejectCompanyRequestModalVisibilityAction(false))
  }

  const onClickSubmit = () => {
    dispatch(rejectCompanyRequestAction({ id: currentRequest.id }))
  }

  const onCloseRejectedSuccessModal = () => {
    dispatch(loadCompaniesAction())
    dispatch(loadCompanyRequestsAction())
    dispatch(setRejectedSuccessModalVisibilityAction(false))
  }

  return (
    <>
      <CompanyFormModal open={rejectCompanyRequestModalVisibility}>
        <ConfirmRejectCompanyContent company={company} onBack={onClickBack} onNext={onClickSubmit} />
      </CompanyFormModal>
      <CompanyFormModal open={rejectedSuccessModalVisibility}>
        <SuccessModalContent title={`${company?.name} rejected!`} onNext={onCloseRejectedSuccessModal} />
      </CompanyFormModal>
    </>
  )
}
